import React, { useState } from 'react';
import { Plus, Trash2, Edit2, Search } from 'lucide-react';
import { primaryButton, ghostButton, inputStyle, glass } from '../ui';
interface Cliente {
  id: string;
  codigo: string;
  nombre: string;
  rnc: string;
  contacto: string;
  telefono: string;
  email: string;
  direccion: string;
  ubicacion: string;
  tipo: 'Industria' | 'Comercio' | 'Residencial' | 'Otro';
  capacidadTanque: number;
  estado: 'activo' | 'inactivo';
  observaciones: string;
  fecha_registro: string;
  ultima_compra?: string;
  dias_sin_comprar?: number;
}
interface ClientesProps {
  clientes: Cliente[];
  onAddCliente: (cliente: Cliente) => void;
  onDeleteCliente: (id: string) => void;
  onUpdateCliente: (cliente: Cliente) => void;
}
export function Clientes({
  clientes,
  onAddCliente,
  onDeleteCliente,
  onUpdateCliente
}: ClientesProps) {
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterEstado, setFilterEstado] = useState<'todos' | 'activo' | 'inactivo'>('todos');
  const [formData, setFormData] = useState<Partial<Cliente>>({
    tipo: 'Comercio',
    estado: 'activo',
    capacidadTanque: 1000
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.codigo || !formData.nombre || !formData.email) {
      alert('Por favor completa los campos obligatorios');
      return;
    }
    if (editingId) {
      onUpdateCliente({
        ...formData,
        id: editingId
      } as Cliente);
      setEditingId(null);
    } else {
      onAddCliente({
        ...formData,
        id: Date.now().toString(),
        fecha_registro: new Date().toISOString().split('T')[0]
      } as Cliente);
    }
    setFormData({
      tipo: 'Comercio',
      estado: 'activo',
      capacidadTanque: 1000
    });
    setShowForm(false);
  };
  const handleEdit = (cliente: Cliente) => {
    setFormData(cliente);
    setEditingId(cliente.id);
    setShowForm(true);
  };
  const filteredClientes = clientes.filter(c => {
    const matchSearch = c.codigo.toLowerCase().includes(searchTerm.toLowerCase()) || c.nombre.toLowerCase().includes(searchTerm.toLowerCase()) || c.email.toLowerCase().includes(searchTerm.toLowerCase());
    const matchEstado = filterEstado === 'todos' || c.estado === filterEstado;
    return matchSearch && matchEstado;
  });
  const clientesActivos = clientes.filter(c => c.estado === 'activo').length;
  const clientesInactivos = clientes.filter(c => c.estado === 'inactivo').length;
  return <div className="space-y-6" data-id="element-157">
      {/* Header Stats */}
      <div className="grid grid-cols-3 gap-4" data-id="element-158">
        <div style={glass} data-id="element-159">
          <div className="text-sm text-gray-400" data-id="element-160">Total Clientes</div>
          <div className="text-3xl font-bold text-blue-400" data-id="element-161">
            {clientes.length}
          </div>
        </div>
        <div style={glass} data-id="element-162">
          <div className="text-sm text-gray-400" data-id="element-163">Activos</div>
          <div className="text-3xl font-bold text-green-400" data-id="element-164">
            {clientesActivos}
          </div>
        </div>
        <div style={glass} data-id="element-165">
          <div className="text-sm text-gray-400" data-id="element-166">Inactivos</div>
          <div className="text-3xl font-bold text-red-400" data-id="element-167">
            {clientesInactivos}
          </div>
        </div>
      </div>

      {/* Controles */}
      <div style={glass} data-id="element-168">
        <div className="flex gap-4 flex-wrap" data-id="element-169">
          <div className="flex-1 min-w-[250px] relative" data-id="element-170">
            <Search className="absolute left-3 top-3 w-4 h-4 text-gray-400" data-id="element-171" />
            <input type="text" placeholder="Buscar por código, nombre o email..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} style={{
            ...inputStyle,
            paddingLeft: 38
          }} data-id="element-172" />
          </div>
          <select value={filterEstado} onChange={e => setFilterEstado(e.target.value as any)} style={{
          ...inputStyle,
          width: 'auto'
        }} data-id="element-173">
            <option value="todos" data-id="element-174">Todos los estados</option>
            <option value="activo" data-id="element-175">Activos</option>
            <option value="inactivo" data-id="element-176">Inactivos</option>
          </select>
          <button onClick={() => {
          setShowForm(!showForm);
          setEditingId(null);
          setFormData({});
        }} style={primaryButton} data-id="element-177">
            <Plus className="w-4 h-4" data-id="element-178" /> Nuevo Cliente
          </button>
        </div>
      </div>

      {/* Formulario */}
      {showForm && <div style={glass} data-id="element-179">
          <h3 className="text-lg font-bold mb-4" data-id="element-180">
            {editingId ? 'Editar Cliente' : 'Nuevo Cliente'}
          </h3>
          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-181">
            <div className="grid grid-cols-2 gap-4" data-id="element-182">
              <div data-id="element-183">
                <label className="text-sm text-gray-300" data-id="element-184">Código *</label>
                <input type="text" value={formData.codigo || ''} onChange={e => setFormData({
              ...formData,
              codigo: e.target.value
            })} style={inputStyle} placeholder="CLI-001" data-id="element-185" />
              </div>
              <div data-id="element-186">
                <label className="text-sm text-gray-300" data-id="element-187">
                  Nombre de Empresa *
                </label>
                <input type="text" value={formData.nombre || ''} onChange={e => setFormData({
              ...formData,
              nombre: e.target.value
            })} style={inputStyle} placeholder="Nombre empresa" data-id="element-188" />
              </div>
              <div data-id="element-189">
                <label className="text-sm text-gray-300" data-id="element-190">RNC</label>
                <input type="text" value={formData.rnc || ''} onChange={e => setFormData({
              ...formData,
              rnc: e.target.value
            })} style={inputStyle} placeholder="123456789" data-id="element-191" />
              </div>
              <div data-id="element-192">
                <label className="text-sm text-gray-300" data-id="element-193">Tipo de Cliente</label>
                <select value={formData.tipo || 'Comercio'} onChange={e => setFormData({
              ...formData,
              tipo: e.target.value as any
            })} style={inputStyle} data-id="element-194">
                  <option data-id="element-195">Industria</option>
                  <option data-id="element-196">Comercio</option>
                  <option data-id="element-197">Residencial</option>
                  <option data-id="element-198">Otro</option>
                </select>
              </div>
              <div data-id="element-199">
                <label className="text-sm text-gray-300" data-id="element-200">
                  Persona de Contacto
                </label>
                <input type="text" value={formData.contacto || ''} onChange={e => setFormData({
              ...formData,
              contacto: e.target.value
            })} style={inputStyle} placeholder="Nombre contacto" data-id="element-201" />
              </div>
              <div data-id="element-202">
                <label className="text-sm text-gray-300" data-id="element-203">Teléfono</label>
                <input type="tel" value={formData.telefono || ''} onChange={e => setFormData({
              ...formData,
              telefono: e.target.value
            })} style={inputStyle} placeholder="+1-809-..." data-id="element-204" />
              </div>
              <div data-id="element-205">
                <label className="text-sm text-gray-300" data-id="element-206">Email *</label>
                <input type="email" value={formData.email || ''} onChange={e => setFormData({
              ...formData,
              email: e.target.value
            })} style={inputStyle} placeholder="empresa@email.com" data-id="element-207" />
              </div>
              <div data-id="element-208">
                <label className="text-sm text-gray-300" data-id="element-209">Ubicación</label>
                <input type="text" value={formData.ubicacion || ''} onChange={e => setFormData({
              ...formData,
              ubicacion: e.target.value
            })} style={inputStyle} placeholder="Zona/Región" data-id="element-210" />
              </div>
              <div data-id="element-211">
                <label className="text-sm text-gray-300" data-id="element-212">
                  Capacidad Tanque (galones)
                </label>
                <input type="number" value={formData.capacidadTanque || 1000} onChange={e => setFormData({
              ...formData,
              capacidadTanque: parseInt(e.target.value)
            })} style={inputStyle} placeholder="1000" data-id="element-213" />
              </div>
              <div data-id="element-214">
                <label className="text-sm text-gray-300" data-id="element-215">Estado</label>
                <select value={formData.estado || 'activo'} onChange={e => setFormData({
              ...formData,
              estado: e.target.value as any
            })} style={inputStyle} data-id="element-216">
                  <option value="activo" data-id="element-217">Activo</option>
                  <option value="inactivo" data-id="element-218">Inactivo</option>
                </select>
              </div>
              <div className="col-span-2" data-id="element-219">
                <label className="text-sm text-gray-300" data-id="element-220">Dirección</label>
                <input type="text" value={formData.direccion || ''} onChange={e => setFormData({
              ...formData,
              direccion: e.target.value
            })} style={inputStyle} placeholder="Dirección completa" data-id="element-221" />
              </div>
              <div className="col-span-2" data-id="element-222">
                <label className="text-sm text-gray-300" data-id="element-223">Observaciones</label>
                <textarea value={formData.observaciones || ''} onChange={e => setFormData({
              ...formData,
              observaciones: e.target.value
            })} style={inputStyle} rows={3} placeholder="Notas adicionales..." data-id="element-224" />
              </div>
            </div>
            <div className="flex gap-2" data-id="element-225">
              <button type="submit" style={primaryButton} data-id="element-226">
                {editingId ? 'Actualizar' : 'Guardar'} Cliente
              </button>
              <button type="button" onClick={() => {
            setShowForm(false);
            setEditingId(null);
          }} style={ghostButton} data-id="element-227">
                Cancelar
              </button>
            </div>
          </form>
        </div>}

      {/* Lista de Clientes */}
      <div style={glass} data-id="element-228">
        <h3 className="text-lg font-bold mb-4" data-id="element-229">
          Clientes ({filteredClientes.length})
        </h3>
        <div className="overflow-x-auto" data-id="element-230">
          <table className="w-full text-sm" data-id="element-231">
            <thead data-id="element-232">
              <tr className="border-b border-gray-700" data-id="element-233">
                <th className="text-left py-2 px-2" data-id="element-234">Código</th>
                <th className="text-left py-2 px-2" data-id="element-235">Empresa</th>
                <th className="text-left py-2 px-2" data-id="element-236">Tipo</th>
                <th className="text-left py-2 px-2" data-id="element-237">Contacto</th>
                <th className="text-left py-2 px-2" data-id="element-238">Teléfono</th>
                <th className="text-left py-2 px-2" data-id="element-239">Tanque (gal)</th>
                <th className="text-left py-2 px-2" data-id="element-240">Estado</th>
                <th className="text-center py-2 px-2" data-id="element-241">Acciones</th>
              </tr>
            </thead>
            <tbody data-id="element-242">
              {filteredClientes.length === 0 ? <tr data-id="element-243">
                  <td colSpan={8} className="text-center py-4 text-gray-400" data-id="element-244">
                    No hay clientes
                  </td>
                </tr> : filteredClientes.map(cliente => <tr key={cliente.id} className="border-b border-gray-700 hover:bg-gray-800/30" data-id="element-245">
                    <td className="py-2 px-2 font-mono text-blue-400" data-id="element-246">
                      {cliente.codigo}
                    </td>
                    <td className="py-2 px-2 font-semibold" data-id="element-247">
                      {cliente.nombre}
                    </td>
                    <td className="py-2 px-2 text-xs bg-gray-800 px-2 py-1 rounded" data-id="element-248">
                      {cliente.tipo}
                    </td>
                    <td className="py-2 px-2" data-id="element-249">{cliente.contacto}</td>
                    <td className="py-2 px-2" data-id="element-250">{cliente.telefono}</td>
                    <td className="py-2 px-2" data-id="element-251">{cliente.capacidadTanque}</td>
                    <td className="py-2 px-2" data-id="element-252">
                      <span className={`text-xs px-2 py-1 rounded ${cliente.estado === 'activo' ? 'bg-green-900 text-green-200' : 'bg-red-900 text-red-200'}`} data-id="element-253">
                        {cliente.estado}
                      </span>
                    </td>
                    <td className="py-2 px-2 text-center" data-id="element-254">
                      <button onClick={() => handleEdit(cliente)} className="text-blue-400 hover:text-blue-300 mr-2" data-id="element-255">
                        <Edit2 className="w-4 h-4" data-id="element-256" />
                      </button>
                      <button onClick={() => onDeleteCliente(cliente.id)} className="text-red-400 hover:text-red-300" data-id="element-257">
                        <Trash2 className="w-4 h-4" data-id="element-258" />
                      </button>
                    </td>
                  </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}